// extracted by mini-css-extract-plugin
export default {"action_loading":"MapLoader_action_loading__Npbno","gif_wrapper":"MapLoader_gif_wrapper__VYFCT","loading_text":"MapLoader_loading_text__ALAKX"};